<template>
  <custom-dialog
    width="1350px"
    class="bind-bank-flow-dialog"
    :visible="visible"
    :append-to-body="true"
    v-on="$listeners"
    :title="title"
  >
    <div class="dialog-body">
      <div class="search-hd">
        <el-form
          :inline="true"
          @submit.native.prevent
        >
          <!-- 更多搜索 -->
          <el-form-item style="float: right">
            <switch-button
              :link="link"
              ref="btn"
            ></switch-button>
          </el-form-item>

        </el-form>
      </div>
      <switch-container
        ref="container"
        @search="onPageChange({ page: 1 })"
        @clear="clearFilter()"
      >
        <el-form
          :inline="true"
          label-position="top"
        >
          <el-form-item :label="$t('fms_bind_bank_flow_dialog.dao_zhang_shi_jian')">
            <custom-date-picker
              v-model="formSearch.tradeFinishTime"
              :init-value="tradeFinishTime"
              value-format="YYYY-MM-DD HH:mm:ss"
              type="daterange"
              :key="billPaymentTimeKey"
            ></custom-date-picker>
          </el-form-item>
          <el-form-item :label="$t('fms_bind_bank_flow_dialog.zhai_yao')">
            <el-input
              v-model="formSearch.sellerTradeRemark"
              :placeholder="$t('fms_bind_bank_flow_dialog.zhai_yao')"
              clearable
              @input="onPageChange({ page: 1 })"
            ></el-input>
          </el-form-item>
        </el-form>
      </switch-container>
      <div class="table-bd">
        <custom-table
          type="checkbox"
          :data="tableList"
          tableCode="bind_bank_flow"
          v-model="selectedData"
          @filter="filterChange"
          @sort="sortChange"
          :slots="['sellerTradeRemark']"
          :clickSelection="true"
        >
          <template v-slot:sellerTradeRemark="scope">
            {{ scope.row.sellerTradeRemark || scope.row.buyerTradeRemark }}
          </template>
        </custom-table>
      </div>
    </div>
    <div
      class="dialog-footer"
      slot="footer"
    >
      <el-button @click="onCancel">{{ $t('Common.com_cancel') }}</el-button>
      <el-button
        type="primary"
        @click="onConfirm"
      >{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
/** 关联银行流水 */
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  name: '',
  mixins: [dialogMixins],
  components: {},
  props: {
    // model: {
    //   data: row
    // }
    isRefund: {
      type: Boolean,
      default: false
    },
    // 1:查收入流水 0：查支付流水（退款）
    sellerTradeType: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      link: null,
      formSearch: {
        tradeFinishTime: '',
        totalAmount: '',
        buyerAccount: '',
        pageNum: 1,
        pageSize: 50,
        sellerTradeRemark: '',
      },
      tradeFinishTime: '',
      totalRows: null,
      tableList: [],
      selectedData: [],
      billPaymentTimeKey: 1,
    };
  },
  computed: {
    title() {
      return this.model.title || this.$t('fms_bind_bank_flow_dialog.yhdzjl');
    }
  },
  watch: {},
  filters: {},
  directives: {},
  methods: {
    onPageChange({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    getReqData() {
      const ret = {
        ...this.formSearch,
        // 1:查收入流水 0：查付款流水
        sellerTradeType: this.sellerTradeType,
      };
      if (!ret.tradeFinishTime || !ret.tradeFinishTime.length) {
        ret.tradeFinishTime = '';
      }
      // const buyerId = this.model.data.buyerId;
      // if (ret.tradeFinishTime) {
      //   const date = ret.tradeFinishTime;
      //   ret.tradeFinishTime = [
      //     date,
      //     this.$moment.utc(date).add(1, 'd').subtract(1, 's').format('YYYY-MM-DD HH:mm:ss'),
      //     // moment(date).format('YYYY-MM-DD 00:00:00'),
      //     // moment(date).format('YYYY-MM-DD 23:59:59')
      //   ];
      // }
      // if (this.isReverse) {
      //   const temp = {
      //     ...ret
      //   };
      //   ret.buyerAccount = temp.sellerAccount;
      //   ret.sellerId = buyerId;
      //   ret.sellerAccount = temp.buyerAccount;
      // }
      return ret;
    },
    getTableList() {
      this.$getJSON(apis.tradeSellerPage4payment, this.getReqData()).then((res) => {
        this.tableList = res.data.records;
        this.totalRows = res.data.total;
      });
    },
    closeDialog() {
      this.visible = false;
    },
    onCancel() {
      this.closeDialog();
    },
    initFormSearch() {
      const { sellerId, totalAmount, sellerAccount, buyerAccount, tradeFinishTime } = this.model.data;
      this.formSearch.sellerId = sellerId;
      this.formSearch.totalAmount = totalAmount;
      this.formSearch.sellerAccount = sellerAccount;
      this.formSearch.buyerAccount = buyerAccount;
      const nextDate = this.$moment(tradeFinishTime).add(1, 'd').subtract(1, 's').format('YYYY-MM-DD HH:mm:ss');
      this.tradeFinishTime = [this.$momentElLocal(tradeFinishTime), this.$momentElLocal(nextDate)];
    },
    onConfirm() {
      if (!this.selectedData.length) {
        this.$message.error(this.$t('fms_bind_bank_flow_dialog.qxzyhls'));
        return;
      }
      if (this.selectedData.length > 1) {
        this.$message.error(this.$t('fms_bind_bank_flow_dialog.znxzygyhls'));
        return;
      }
      const bankItem = this.selectedData[0];
      const { tradeId } = this.model.data;
      const { sellerTradeCode } = bankItem;
      // 兼容付款信息为本地时(未提交)添加银行流水
      if (!tradeId) {
        this.$message({
          type: 'success',
          message: this.$t('Common.com_handle_success'),
        });
        this.closeDialog();
        this.$emit('success', bankItem, true);
        return;
      }
      this.$postJSON(`${apis.paymentBankFlowBind}/${tradeId}/${sellerTradeCode}`, {}, true).then(() => {
        this.$message({
          type: 'success',
          message: this.$t('Common.com_handle_success'),
        });
        this.closeDialog();
        this.$emit('success', bankItem);
      });
    },
    // 过滤
    clearFilter: function () {
      this.formSearch = JSON.parse(this.resetFormSearch);
      // 然后日期组件重新根据init-value赋值
      this.billPaymentTimeKey++;
      setTimeout(() => {
        this.onPageChange({ page: 1 });
      }, 300);
    },
  },
  created() { },
  mounted() {

    setTimeout(() => {
      this.link = this.$refs.container;
      setTimeout(() => {
        this.$refs.btn.onClick();
      }, 100);
    }, 100);
    this.initFormSearch();
    this.resetFormSearch = JSON.stringify(this.formSearch);
    setTimeout(() => {
      this.getTableList();
    }, 500);
  },
};
</script>

<style lang="scss">
.bind-bank-flow-dialog {
  .dialog-body {
    padding-top: 0 !important;
  }
}
</style>
